module.exports = __webpack_public_path__ + "src/img/artist/indexpic04.jpg?ebb9d99b8eb694c865b5b9ec2d0a95be";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/indexpic04.jpg
// module id = 131
// module chunks = 0